<script>
import {getProductLineAuthorization} from "../../../../../api/international";
import {mapState} from "vuex";
import eventBus from "../../../../../utils/eventBus";

export default {
  name: "purchaseSettingsInPartnerCenter",
  props: {
    // 编辑类型 基础 base 或者 高级senior 默认基础
    mode: {
      type: String,
      default: "base"
    },
    // 操作类型 申请 apply, 编辑 edit, 审批 approve， 默认申请
    type: {
      type: String,
      default: "apply"
    },
    isApply: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    detailData: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      formData: {
        authClassifyIds: []
      },
      isInit: !this.isApply,
      authClassifyList: []
    }
  },
  computed: {
    ...mapState("smbSales", ["selectCountryAndRegion", "partnerContractInfo"]),
    ...mapState(["user"]),
    rules() {
      return {
        authClassifyIds: [
          { required: true, message: 'please select authorized product type', type: 'array' }
        ]
      }
    },
    isCanEdit () {
      if (!this.user) return false
      const { userId, businessEmail} = this.user
      if (!userId && !businessEmail) return false
      return (
        userId.includes('@ruijienetworks.com') ||
        userId.includes('@ruijie.com.cn') ||
        userId.includes('@ruijie.com') ||
        businessEmail.includes('@ruijienetworks.com') ||
        businessEmail.includes('@ruijie.com.cn') ||
        businessEmail.includes('@ruijie.com')
      ) && (this.partnerContractInfo.partnerType === 'VAD' || (this.detailData && this.detailData.partnerType === 'VAD'))
    }
  },
  watch: {
    'partnerContractInfo.partnerType': {
      handler(newVal) {
        if (this.isInit) return
        // 如果发生了变化 清空formData 前提是他能看到的情况下
        if (this.isCanEdit) {
          this.formData.authClassifyIds = []
        }
      }
    }
  },
  methods: {
    setFormData(formData) {
      let formDataCopy = JSON.parse(JSON.stringify(formData));
      if (formData.partnerType === "VAD")  {
        try {
          this.formData.authClassifyIds = formDataCopy.authClassifyIds.split(',');
        }catch (e) {
          this.formData.authClassifyIds = []
        }
      } else {
        this.formData.authClassifyIds = []
      }
      // 初始化完毕
      this.$nextTick(() => {
        this.isInit = false;
      });
    },
    // 获取formData
    getFormData() {
      if (this.isDetail) {
        return;
      }
      // 非vad 或者 不是内部用户 且不是详情 直接返回 ‘’
      if (!this.isCanEdit) {
        console.log(this.formData.authClassifyIds)
        return {
          // 直接返回原本数据
          authClassifyIds: this.formData.authClassifyIds ? this.formData.authClassifyIds.join(',') : ''
        }
      }
      let isPass = false;
      this.$refs.form.validate(isSuccess => {
        isPass = isSuccess;
      });
      if (isPass) {
        console.log(this.formData.authClassifyIds)
        return {
          authClassifyIds: this.formData.authClassifyIds ? this.formData.authClassifyIds.join(',') : ''
        }
      } else {
        return isPass;
      }
    },
    changeFormData(authClassifyIds) {
      if (!authClassifyIds) return
      if (typeof authClassifyIds === "string") {
        this.formData.authClassifyIds = authClassifyIds.split(',')
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      }
      if (Array.isArray(authClassifyIds)) {
        this.formData.authClassifyIds = authClassifyIds
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      }
    }
  },
  mounted() {
    getProductLineAuthorization().then(response => {
      const { status, data } = response
      if (Number(status) === 200) {
        this.authClassifyList = data
      }
    })
    eventBus.$on('purchaseSettingsInPartnerCenterSetFormData', this.changeFormData);
  },
  beforeDestroy() {
    eventBus.$off('purchaseSettingsInPartnerCenterSetFormData', this.changeFormData);
  },
}
</script>

<template>
  <div class="smb-sales_container" v-if="isCanEdit">
    <div
      class="smb-sales_container_title"
    >
      Purchase Settings in Partner Center
    </div>
    <div class="smb-sales_container_content" v-if="isApply || isEdit">
      <el-form
        ref="form"
        label-position="top"
        :model="formData"
        :rules="rules"
      >
        <el-form-item prop="authClassifyIds">
          <template #label>
            <div class="smbsales-label_required" style="display: flex; align-items: center;gap: 5px;">
              Authorized Product Types
              <el-tooltip placement="top-start" effect="light" popper-class="custom-tooltip">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 48 48" fill="rgba(128, 128, 128, 1)">
                  <path fill="none" d="M0 0h48v48H0V0z"/>
                  <path d="M22 30h4v4h-4zm0-16h4v12h-4zm1.99-10C12.94 4 4 12.95 4 24s8.94 20 19.99 20S44 35.05 44 24 35.04 4 23.99 4zM24 40c-8.84 0-16-7.16-16-16S15.16 8 24 8s16 7.16 16 16-7.16 16-16 16z"/>
                </svg>
                <template #content>
                  <div class="text-content">
                    Partners can buy the Authorized product type in the Partner Center
                  </div>
                </template>
              </el-tooltip>
            </div>
          </template>
          <el-checkbox-group v-model="formData.authClassifyIds">
            <el-checkbox v-for="item in authClassifyList" :key="item.label" :label="item.value"> {{ item.label }} </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </div>
    <div class="smb-sales_container_content" v-else>
      <el-row>
        <el-col :span="12">
          <div class="smb-sales_label">Authorized Product Types</div>
          <div class="smb-sales_value">
            {{ detailData ? detailData.authClassifyIds ? detailData.authClassifyIds.split(',').map(item => {
              let temp = authClassifyList.find((item1) => item1.value === item)
              return temp ? temp.label : ''
            }).join(', ') : "-": "-" }}
          </div>
        </el-col>

      </el-row>

    </div>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/channelAgreement/twentyTwentyFive/SBG/components/purchaseSettingsInPartnerCenter.vue